export const sharedMobile = {
    apartment: {
        total: {
            paid: 'Paid at {{year}}',
            special: 'Special debts',
            ongoing: 'Ongoing debts',
            up_to_date: 'Up to date',
        },
        paid_payments: {
            title: 'Recent payments',
            receipt: 'receipt',
        },
        future_payments: {
            title: 'Future payments',
            for: 'For:',
            ongoing_total: 'Total future ongoing:',
            number_of_payments: 'Number of payments:',
            cancel_dialog: {
                title: "Cancel Payments",
                description: "Select the future payments you want to cancel",
                date: "Payment Date",
                amount: "Amount",
                cancel_all: "Cancel All Future Payments",
                cancel_selected: "Cancel Selected Payments"
            },
            "cancel_button": "Cancel Plan",
            cant_cancel_direct_payment: "Cannot cancel payments made directly to building"
        },
        delete_details_button: {
            main_button_title: 'delete my details',
            dialog_title: 'Delete My Details',
            dialog_subtitle: 'Are you sure you want to delete all your details? This action cannot be undone.',
            dialog_button: 'Delete Details',
            delete_done: 'Your details have been deleted (fake action)',
            delete_failed: 'Could not delete details, try again later'
        },
        show_more: 'show more',
        paid_for: 'Payment for:',
        comment: 'Comment:',
    }
}
